/**
 * Liste les code erreus de l'api
 */
export const codes = {
  invalid_grant: 'Combinaison utilisateur / mot de passe incorrecte',
  access_denied: 'Votre compte est désactivé',
  100: 'Des paramètres sont manquants',
  201: `L'adresse mail de cet utilisateur est déjà utilisée`,
  702: 'Le badge est déjà utilisé',
  703: 'Le point de contrôle est déjà validé'
}
